class AvantRouter{
  constructor($httpProvider, $stateProvider, $sceDelegateProvider, $urlMatcherFactoryProvider){
    this.$httpProvider        = $httpProvider
    this.$sceDelegateProvider = $sceDelegateProvider
    this.$stateProvider       = $stateProvider
    this.states = {
      loading: {
        url: '/',
        templateUrl: ()=> "/customer_application_renderer/stages/home/form.html",
        controllerProvider: ['$stateParams', ($stateParams) => this.controllerForStage('loading') ]
      },
      service_failure: {
        url: '/service_failure',
        params: { reasons: [] },
        templateUrl: () =>"/customer_application_renderer/stages/service_failure/form.html",
        controllerProvider: ['$stateParams', ($stateParams) => this.controllerForStage('service_failure') ]
      },
      scheduled_maintenance: {
        url: '/scheduled_maintenance',
        templateUrl: () =>"/customer_application_renderer/stages/scheduled_maintenance/form.html",
        controllerProvider: ['$stateParams', ($stateParams) => this.controllerForStage('scheduled_maintenance') ]
      },
      customer_application: {
        url: '/:stage',
        resolve: this.defaultResolve(),
        templateUrl: function(params){
          return `/customer_application_renderer/stages/${params.stage}/form.html`
        },
        controllerProvider: ['$stateParams', ($stateParams) => this.controllerForStage($stateParams.stage)]
      },
      redirect: {
        url: '/redirect/:to',
        template: '',
        controller: 'CustomerApplicationsRedirectCtrl'
      }
    }
  }
  configureHttpProvider(){
    //#initialize get if not there
    this.$httpProvider.defaults.headers.get = this.$httpProvider.defaults.headers.get || {}
    //#disable ajax request caching
    this.$httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache'
    this.$httpProvider.defaults.headers.get['Pragma'] = 'no-cache'
    //#disable ajax request caching in IE
    this.$httpProvider.defaults.headers.get['If-Modified-Since'] = 'Sat, 1 Jan 2000 05:00:00 GMT'
    this.$httpProvider.interceptors.push('AuthenticationFailureInterceptor')
    this.$httpProvider.interceptors.push('ServerErrorInterceptor')
    this.$httpProvider.interceptors.push('RequestTimestamp')

    this.$sceDelegateProvider.resourceUrlWhitelist [
      'self',
      'https://img2.avant.com/**',
      'https://img2.avantcredit.co.uk/**',
      'https://img2.my.eloan.com/**',
      'https://im2.prod.amount.com/**',
      // The following URL can be removed once https://github.com/amount/avant-basic/pull/37178
      // has been deployed to TD production
      'https://im2.tdfitloan.com/**',
      'https://im2.personalloanapply.us.hsbc.com/**',
      'https://im2.personalloans.pnc.com/**',
      'https://im2.regions.prod.amount.com',
      'https://track.omguk.com/**'
    ]
  }


  configureDefaultStates(){
    Object.keys(this.states).map((key) => this.$stateProvider.state(key, this.states[key]))
  }

  controllerForStage(stage){
    const formatted_stage = stage.split('_').map((str) =>
      str.charAt(0).toUpperCase() + str.slice(1)
    ).join('')
    return `CustomerApplications${formatted_stage}Ctrl`
  }


  defaultResolve(){
    return {
      progress: [
      'ApplicationService', (ApplicationService) => ApplicationService.getProgress()
        .then((response_data) =>{
          $('html, body').clearQueue().animate({ scrollTop: 0 }, 'fast')
          return response_data
        }, (response) => response
        )
      ]
    }
  }
  $get(){}
}

AvantRouter.$inject = [
  "$httpProvider",
  "$stateProvider",
  "$sceDelegateProvider",
  "$urlMatcherFactoryProvider",
];

angular
.module("avant.customer_applications.factories")
.provider("avantRouter", AvantRouter)

if (typeof exports !== 'undefined') {
  if (typeof module !== 'undefined' && module.exports) {
    exports = module.exports = AvantRouter;
  }
  exports.AvantRouter = AvantRouter;
} else {
  window.AvantRouter = AvantRouter;
}
